import { Brain, Sparkles } from 'lucide-react';

export function Logo() {
  return (
    <div className="flex items-center gap-2">
      <div className="relative">
        <Brain className="w-8 h-8 text-blue-400" />
        <Sparkles className="w-4 h-4 text-purple-400 absolute -top-1 -right-1" />
      </div>
      <div className="font-bold text-xl bg-gradient-to-r from-blue-400 to-purple-600 text-transparent bg-clip-text">
        AIGC-DAO
      </div>
    </div>
  );
}